import styles from '@/styles/category/filter-item.module.scss'
import { useState } from 'react'
import Link from 'next/link'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

// 定义分类项接口
interface sideFilterItem {
  name: string;
  description?: string;
  url: string;
  isSelected: boolean;
  count?: boolean;
}

interface Props {
  filterTypeItem: {
    title: string;
    key: string;
    items: sideFilterItem[]
  }
}

export default function CategoryFilterItem({ filterTypeItem }: Props) {
  const [showMore, setShowMore] = useState(false);

  // 切换是否展示更多
  const toggleShowMore = () => {
    setShowMore(!showMore)
  };

  return (
    <>
      {
        !!(filterTypeItem && filterTypeItem.items.length) &&
        <div className={styles['comp-filter-item']}>
          <div className={styles['title']}>{filterTypeItem.title}</div>

          <div className={`${styles['item-list']} ${showMore ? styles['item-list-all'] : ''}`}>
            {
              filterTypeItem.items.map((item: sideFilterItem, index: number) => (
                <Link
                  href={item.url || ''}
                  key={item.url || filterTypeItem.title + index}
                  legacyBehavior
                >
                  <a rel="noopener noreferrer">
                    <div className={styles['item']}>
                      <div className={`${styles['item-name']} ${item.isSelected ? styles['active'] : ''}`}>
                        {item.name}
                        {
                          !!(item?.description) &&
                          <span className={styles['item-description']}>&nbsp;({item.description})</span>
                        }
                      </div>
                      {
                        !!(item?.count) &&
                        <div className={styles['item-count']}>&nbsp;({item.count})</div>
                      }
                    </div>
                  </a>
                </Link>
              ))
            }
          </div>

          {
            !!(filterTypeItem.items.length > 10) &&
            <div className={styles['show-more-btn']} onClick={toggleShowMore}>
              Show More&nbsp;
              {
                showMore ?
                <CaretUpOutlined
                  color={'#999999'}
                  style={{ marginTop: '2px' }}
                />
                :
                <CaretDownOutlined
                  color={'#999999'}
                  style={{ marginTop: '2px' }}
                />
              }
            </div>
          }
        </div>
      }
    </>
  )
}